export const themes = {
  inline: 'inline',
  overlay: 'overlay',
  fullScreenOverlay: 'full-screen-overlay',
} as const;

export const sizes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const colors = {
  blue: 'blue',
  orange: 'orange',
  white: 'white',
} as const;

export type SpinnerProps = {
  text?: string;
  size?: (typeof sizes)[keyof typeof sizes];
  theme?: (typeof themes)[keyof typeof themes];
  color?: (typeof colors)[keyof typeof colors];
};
